import { useEffect, useState } from 'react';

import { isInselNetwork } from 'services/network';

const IP_ECHO_URL = 'https://api.ipify.org?format=json';

type State = {
    isInsel: boolean;
    loaded: boolean;
};

// Whether the current React app visitor is on the Insel network (161.62.0.0/16)
// — see MAINTENANCE_MODE.md. A browser can't read its own IP directly, so this
// asks a public IP-echo service what this browser's own effective public IP
// is (the address Insel's network egresses through) and checks that against
// the range — this is the visitor's own IP, not anything the backend reports.
// REACT_APP_ALLOW_LOCAL_TEST_MODE (set per-developer in .env.development.local)
// short-circuits this for local dev, where there's no real Insel egress IP.
function useIsInselNetwork(): State {
    const allowLocalTestMode = process.env.REACT_APP_ALLOW_LOCAL_TEST_MODE === 'true';
    const [state, setState] = useState<State>({ isInsel: allowLocalTestMode, loaded: allowLocalTestMode });

    useEffect(() => {
        if (allowLocalTestMode) {
            return;
        }

        let cancelled = false;

        fetch(IP_ECHO_URL)
            .then((response) => response.json())
            .then((result) => {
                if (!cancelled) {
                    setState({ isInsel: isInselNetwork(result.ip), loaded: true });
                }
            })
            .catch(() => {
                if (!cancelled) {
                    setState({ isInsel: false, loaded: true });
                }
            });

        return () => {
            cancelled = true;
        };
    }, [allowLocalTestMode]);

    return state;
}

export default useIsInselNetwork;
